import gutter from '../../../config/vars';
const containerDesktop={
  width:"450px",
  padding:"24px "+ gutter,
  border:"8px solid #fff",
  lineHeight: "26.67px",
  position: "absolute",
  left:"50%",
  transform:"translate(-50%)",
  bottom: "32px",
  textAlign:"left"
}

const containerMobile={
  width:"100%",
  padding:"24px "+gutter,
  border:"0px solid #fff",
  lineHeight: "26.67px",
  //position: "absolute",
  left:"0",
  bottom:"-1px",
  textAlign:"left",
  height:"auto",
}

export default{
  containerStyles:window.innerWidth>899?containerDesktop:containerMobile,
}